export default __webpack_public_path__ + "static/media/floaters-large@3x.c0f50ec0.jpg";